//This mixin depends on the existence of the TestStateMixin for this.isRealTest to work.
import {TestModeSettings, imageUrls} from 'Shared'

export default {
    computed: {
        showGreen()         { return this.isRealTest && this.isInSpecialTestMode },
        isInSpecialTestMode() {
           return !this.isDemo && !this.isBookmarkRevision && !this.isRevision && !this.isRevisionResults && !this.isStatistics && !this.isRealTestStats
        },

        currentMode()       { return TestModeSettings.testModeName(this.isRealTest) },
        modeIcon()          { return TestModeSettings.testModeIcon(this.isRealTest && this.isInSpecialTestMode) },
        clockIcon()         { return TestModeSettings.testClockIcon(this.isRealTest && this.isInSpecialTestMode) },
        modeFgColor()       { return TestModeSettings.testModeFgColor(this.isRealTest && this.isInSpecialTestMode) },
        modeBgColor()       { return TestModeSettings.testModeBgColor(this.isRealTest && this.isInSpecialTestMode) },
        modeColor()         { return TestModeSettings.testModeColor(this.isRealTest && this.isInSpecialTestMode) },


        allgemeinWissenIcon()           { this.getMainCatIconFor('allgemeinWissen') },
        erinnerungsVermoegenIcon()      { this.getMainCatIconFor('erinnerung') },
        fachWissenIcon()                { this.getMainCatIconFor('fachWissen') },
        fremdsprachenIcon()             { this.getMainCatIconFor('fremdsprachen') },
        konzentrationIcon()             { this.getMainCatIconFor('konzentration') },
        kreativitaetIcon()              { this.getMainCatIconFor('kreativitaet') },
        logikIcon()                     { this.getMainCatIconFor('logik') },
        matheIcon()                     { this.getMainCatIconFor('mathe') },
        orientierungIcon()              { this.getMainCatIconFor('orientierung') },
        spracheIcon()                   { this.getMainCatIconFor('sprache') },
        technikIcon()                   { this.getMainCatIconFor('technik') },
        visuellesIcon()                 { this.getMainCatIconFor('visuelles') },

    },

    methods: {
        getMainCatIconFor(name) { return this.showGreen ? imageUrls.mainCategories[name] : imageUrls.mainCategories[name+'Green'] }
    }
};